import { Auth } from 'aws-amplify'
import S3 from 'aws-sdk/clients/s3'

export default function s3PresignedUrl(bucket, key, callback) {
    Auth.currentCredentials().then((credentials) => {
        let s3 = new S3({
            apiVersion: '2006-03-01',
            credentials: Auth.essentialCredentials(credentials),
        })

        s3.getSignedUrl('getObject', { Bucket: bucket, Key: key }, callback)
    })
}
